import { Controller } from "@hotwired/stimulus"
import { positionDropdown, resetScrollHint } from "../utils/dropdown_utils"

const SELECTED = ["bg-green-600", "text-white", "border-green-600"]
const UNSELECTED = ["bg-white", "text-gray-700", "border-gray-200", "hover:bg-green-50", "hover:border-green-300"]

// Dropdown time picker: trigger button opens a scrollable grid of time slots.
export default class extends Controller {
  static targets = ["hidden", "trigger", "label", "dropdown", "option", "clearBtn"]

  toggle(event) {
    event.stopPropagation()
    const isOpen = !this.dropdownTarget.classList.contains("hidden")

    if (isOpen) {
      this.dropdownTarget.classList.add("hidden")
    } else {
      document.dispatchEvent(new CustomEvent("dropdown:close-all", { detail: { except: this.element } }))

      positionDropdown(this.dropdownTarget, this.triggerTarget)
      resetScrollHint(this.dropdownTarget)
      this.dropdownTarget.classList.remove("hidden")

      const selected = this.optionTargets.find(btn => btn.classList.contains("bg-green-600"))
      if (selected) {
        selected.scrollIntoView({ block: "center", behavior: "instant" })
      }
    }
  }

  select(event) {
    event.stopPropagation()
    const btn = event.currentTarget
    const value = btn.dataset.timeValue
    const label = btn.dataset.timeLabel

    this.hiddenTarget.value = value
    this.hiddenTarget.dispatchEvent(new Event("change", { bubbles: true }))

    this.labelTarget.textContent = label
    this.labelTarget.classList.remove("text-gray-400")
    this.labelTarget.classList.add("text-gray-900")

    this.optionTargets.forEach(opt => {
      opt.classList.remove(...SELECTED)
      opt.classList.add(...UNSELECTED)
    })
    btn.classList.remove(...UNSELECTED)
    btn.classList.add(...SELECTED)

    this.dropdownTarget.classList.add("hidden")
    if (this.hasClearBtnTarget) this.clearBtnTarget.classList.remove("hidden")
  }

  clear() {
    this.hiddenTarget.value = ""
    this.hiddenTarget.dispatchEvent(new Event("change", { bubbles: true }))

    this.labelTarget.textContent = "Pick a time"
    this.labelTarget.classList.remove("text-gray-900")
    this.labelTarget.classList.add("text-gray-400")

    this.optionTargets.forEach(opt => {
      opt.classList.remove(...SELECTED)
      opt.classList.add(...UNSELECTED)
    })

    this.dropdownTarget.classList.add("hidden")
    if (this.hasClearBtnTarget) this.clearBtnTarget.classList.add("hidden")
  }

  clearValue(event) {
    event.stopPropagation()
    this.clear()
  }

  closeAll(event) {
    if (event.detail?.except !== this.element) {
      this.dropdownTarget.classList.add("hidden")
    }
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add("hidden")
    }
  }

}
